import styled, { css } from 'styled-components';
import { BaSeTheme } from '@base/react';

export const PaddingContainer = styled.div`
  ${({ maxWidth }) =>
    maxWidth &&
    css`
      max-width: ${maxWidth}px;
    `}
  @media screen and (max-width: ${BaSeTheme.breakpoints.tablet.maxWidth}px) {
    padding: 0 8px;
  } ;
`;

export const JumbotronProdutos = styled(PaddingContainer)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;
`;

export const SearchContainer = styled(JumbotronProdutos)`
  align-items: flex-end;
`;

export const InputWrapper = styled.div`
  max-width: ${BaSeTheme.breakpoints.tablet.maxWidth}px;
`;

export const DataTableWrapper = styled.div`
  padding: 24px 0 32px 0;

  /* table.BaSe--data-table > thead > tr{
    background: ${BaSeTheme.colors.institucionais.cinzaSebrae97};
  }
  footer {
    background: ${BaSeTheme.colors.institucionais.cinzaSebrae97};
  } */
`;
